module.exports = __webpack_public_path__ + "static/media/ComputerTalk_Step1b_Image8.10fe02ed.jpg";